const StaffListDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M13.4417 9.55801C13.1975 9.31384 12.8017 9.31384 12.5575 9.55801L11.1242 10.9913V3.33301C11.1242 2.98801 10.8442 2.70801 10.4992 2.70801C10.1542 2.70801 9.87416 2.98801 9.87416 3.33301V10.9905L8.44083 9.55717C8.19666 9.31301 7.80083 9.31301 7.55666 9.55717C7.31249 9.80134 7.31249 10.1972 7.55666 10.4413L10.0567 12.9413C10.1783 13.063 10.3383 13.1247 10.4983 13.1247C10.6583 13.1247 10.8183 13.0638 10.94 12.9413L13.44 10.4413C13.6842 10.1972 13.6842 9.80134 13.44 9.55717L13.4417 9.55801Z"
        fill="#183883"
      />
      <path
        d="M15.4999 17.2917H5.49992C4.23575 17.2917 3.20825 16.2642 3.20825 15V12.5C3.20825 12.155 3.48825 11.875 3.83325 11.875C4.17825 11.875 4.45825 12.155 4.45825 12.5V15C4.45825 15.5742 4.92575 16.0417 5.49992 16.0417H15.4999C16.0741 16.0417 16.5416 15.5742 16.5416 15V12.5C16.5416 12.155 16.8216 11.875 17.1666 11.875C17.5116 11.875 17.7916 12.155 17.7916 12.5V15C17.7916 16.2642 16.7641 17.2917 15.4999 17.2917Z"
        fill="#183883"
      />
    </svg>
  );
};
export default StaffListDownloadIcon;
